import { gql } from '@apollo/client';

export default gql`
  query getExtendedCompensationByTicketNumbers($ticketNumbers: [String!]!, $bookingReference: String) {
    getExtendedCompensationByTicketNumbers(ticketNumbers: $ticketNumbers, bookingReference: $bookingReference) {
      caseId
      cashCompensationAmount
      cashCompensationPercentage
      compensationRecord
      compensationRecordId
      currency
      delayDurationMins
      firstName
      isEligiblePoints
      lastName
      membershipNumber
      method
      onlinePointsAmount
      status
      ticketNumber
      ticketPrice
      voucherCompensationAmount
      voucherCompensationPercentage
      loyaltyTicketPrice
      loyaltyCompensationAmount
      loyaltyCompensationPercentage
    }
  }
`;
